import axios from 'axios'
import qs from 'qs'
var ajax = {
	post(url, data) {
		var that = this;
		var token = localStorage.getItem("Uetoken");
		return new Promise((resolve, reject) => {
			axios.post(url, data, {
				headers: {
					'client_id': 'Ue',
					'Authorization': 'Bearer ' + token,
					'Store': 1,//验证店铺的数据
					'Content-Type': 'application/json',
				}
			}).then((res) => {
				resolve(res);
//				if(res.data.success == false){
//					that.messageCont = res.data.error.message;
//				}
//				if(res.data.success == true) {
//					//成功回调
//					resolve(res);
//				} else {
//					that.messageCont = res.data.error.message;
//				}
			}).catch((error) => {
				reject(error);

			})
		})
	},
}
export default ajax


// WEBPACK FOOTER //
// ./src/js/axios.js